module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner-sec bg bg-9"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bg-content"
  }, [_c('div', {
    staticClass: "box-login"
  }, [_c('h1', {
    staticClass: "lato"
  }, [_vm._v("Recuperar contraseña")]), _vm._v(" "), _c('form', {
    staticClass: "form login-form"
  }, [(_vm.respuesta) ? _c('div', {
    staticClass: "box-success"
  }, [_c('b', [_vm._v("Listo!")]), _vm._v(" Te enviamos un mail para que puedas recupererar tu clave.\n              "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn-link deco-dotted pull-right",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("INGRESAR AL SISTEMA")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ingresa el correo con el que se registró")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-action"
  }, [_c('router-link', {
    staticClass: "btn-link deco-dotted pull-left",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("¿YA TIENES UNA CUENTA?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fill btn-lg size-16",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickEnviar($event)
      }
    }
  }, [_vm._v("ENVIAR")])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2efb680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/Recuperar.vue
// module id = 1170
// module chunks = 5